import { Alert } from "@flat-ui";
import { runtimeConfig } from "@src/runtime-config";
import { useEffect, useState } from "react";

/** Defines the number of seconds to wait before redirecting the user */
const REDIRECTION_TIME_SECONDS = 5;

/** Defines the number of milliseconds in a second */
const MS_IN_SECOND = 1000;

/**
 * Component to display a success message after email verification.
 * It counts down the seconds until redirection.
 */
export function EmailVerifiedRedirection(): JSX.Element {
  const [redirectionIn, setRedirectionIn] = useState<number>(
    REDIRECTION_TIME_SECONDS
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setRedirectionIn((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          prev = 0;
          window.location.assign(runtimeConfig.urls.sphereDashboardUrl);
        }
        return prev - 1;
      });
    }, MS_IN_SECOND);
  }, []);

  return (
    <Alert
      variant="success"
      title="Email Verified"
      description={
        <>
          Your email address has been successfully verified. You will be
          redirected in {redirectionIn} seconds.
        </>
      }
    />
  );
}
